import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { LoanType } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CreateLoanTypeParams {
  name: string;
}

export interface CreateLoanTypeResponse {
  success: boolean;
  message: string;
  loanTypeId: string;
}

const createLoanType: MutationFunction<LoanType, CreateLoanTypeParams> = async (
  args,
) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CreateLoanTypeResponse>(`/loan-types`, {
    method: 'POST',
    body: {
      name: args.name,
    },
  });
  if (response.data)
    return {
      id: response.data.loanTypeId,
      name: args.name,
    };
  throw new Error('Failed to create loan type');
};

export default createLoanType;

const _mockType: LoanType = {
  id: 'test-id',
  name: 'razvan',
};
